<template>
    <div class="i-table alarm-table-container">
        <i-table ref="alarmTable" :data="tableData"  size="small"  :columns="prop.columns" :height="tableHeight" highlight-row stripe>
        </i-table>
        <Row class="i-bottom-link" style="text-align:right; font-size:16px;">
            <a href="javascript:void(0)">more...</a>
        </Row>
    </div>
</template>

<script>
    import CsDynamicTableMixins from './CsDynamicTableMixins'
 
    export default {
        name : 'CsAlarmTable',
        props : ['prop'],
        mixins: [CsDynamicTableMixins],
        data () {
            return {

                tableData : [],
                tableHeight :null,

            }
        },
        methods : {
            initTableData(){
                this.tableData =  this.tableData.length > 0 ? this.tableData : this.prop.tableData ;
            },
            initWindowEvent(){
      	        window.addEventListener('resize', ()=> {
				    this.calculateTableHeight()
				})
            },
            calculateTableHeight(){
      	        let height=jq(".right-div").height()-jq(".i-bottom-link").height()-30;
				this.tableHeight=height;
            },
        },
        mounted() {
            this.initTableData();
            this.initWindowEvent();
    	    this.calculateTableHeight()
        }
    }
</script>

<style scoped>
    .i-bottom-link{
            text-align: right;
            font-size: 16px;
        
    }
    .ivu-table td{
        height : 20px;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/dynamicTable/CsAlarmTable.vue